import { jsx as _jsx } from "react/jsx-runtime";
import { LogEntry } from './logEntry';
export const RatingScheduled = ({ entry, }) => {
    const action = entry.activity_type === 'CONVERSATION_RATING_SCHEDULED'
        ? 'scheduled'
        : 'unscheduled';
    const text = `Conversation rating is ${action}` +
        (entry.rating_scheduled_time
            ? ` at ${new Date(entry.rating_scheduled_time).toLocaleString()}`
            : '');
    return _jsx(LogEntry, { entry: entry, text: text });
};
